import CopyableText from "src/components/CopyableText";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { GetListRes } from "../types/GetListRes";

type Direction = "recipientAddress";

const useCopyableCell = () => {
  const renderCopyableCell =
    (direction: Direction) => (params: Params<GetListRes>) => {
      const getValue = () => {
        switch (direction) {
          case "recipientAddress":
            return params.row.rawData.wallet?.wallet_address;
          default:
            return "";
        }
      };
      return <CopyableText text={getValue()} handleOverflow />;
    };
  return {
    renderCopyableCell,
  };
};
export default useCopyableCell;
